<template>
    <v-row justify="center">
      <v-col cols="12" class="pt-16">
        <v-container>
          <back-button @click.native="$router.go(-1)"></back-button>
          <h3 class="mb-8 home-header-3">
            Have you already had an RSV vaccine earlier in your current pregnancy?
          </h3>
          <v-radio-group
            v-model="rsvPreviouslyReceived"
            class="mb-4"
          >
            <v-radio
              v-on:keyup.enter="
                rsvPreviouslyReceived = 'Yes';
              "
              label="Yes"
              value="Yes"
              color="#006078"
              class="ml-4 px-8 py-4 black--text"
              :ripple="false"
            ></v-radio>
            <v-radio
              v-on:keyup.enter="
                rsvPreviouslyReceived = 'No';
              "
              label="No"
              value="No"
              color="#006078"
              class="ml-4 px-8 py-4 black--text"
              :ripple="false"
            ></v-radio>
          </v-radio-group>
          <v-btn
            @click="onAfterContinueClicked"
            class="v-btn--primary"
            :disabled="!rsvPreviouslyReceived"
          >
            Continue
          </v-btn>
        </v-container>
      </v-col>
    </v-row>
  </template>
  
  <script>
  import Vue from 'vue';
  import BackButton from '@/components/BackButton';
  const codes = {
    RSV: 'RSV'
  }
  export default Vue.extend({
    components: { BackButton },
    name: 'StepRSVPregnancy1',
    data: () => ({
      rsvPreviouslyReceived: null,
      ...codes
    }),
    methods: {
      onAfterContinueClicked() {
        this.$gtag.event('RSV previously received question answered', {})
        if (this.rsvPreviouslyReceived === 'Yes') {
          this.$router.push('/booking/rsv-not-eligible').catch(() => {});
        } else {
            this.$store.commit(
                'setBookingTypes',
                [this.RSV]
            );
            this.$router.push('/booking/eligible').catch(() => {});
        }
      }
    }
  });
  </script>
  